module.exports = __webpack_public_path__ + "resources/img/img_tibero5_jp.668ef6fbe46336785bfaaa67146dd4e8.png";